import React from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import Icon from "components/MainApp/atoms/Icon/icon";
import InputText from "components/MainApp/atoms/Forms/MainInput";
import ItemTags from "components/MainApp/organisms/OrdersV4/Item-Tags";
import DeviceSelector from "components/Functionals/DeviceSelector";
import tagIcon from "assets/images/tag-icon.svg";
import styles from "./LoadReceptionOrder.step2.module.scss";
import i18n from "i18n";
import TagReadInput from "shared/components/Input/TagReadInput";

export const ReceptionOrderStep2 = ({
  enabledRead,
  typeRead,
  refRead,
  associateRead,
  priorityRead,
  receiveEvent,
  originalItems,
  selectedItems,
  searchValue,
  handleSearch,
  searchedValue,
  goBackFunc,
  handleDelete,
  handleDeleteAll,
  handleSend,
  title,
}) => {
  const stepContent = (
    <div className={styles["reception-order-step-two-content"]}>
      <div
        className={[
          styles["step-title-wrapper"],
          goBackFunc ? styles["go-back"] : ""
        ].filter(Boolean).join(" ")}
        // onClick={goBackFunc}
        // data-automation-id="go-back-step"
      >
        {/* {goBackFunc && <i className="step-back-icon icon-chevron-izquierda"></i>} */}
        <div className={styles["step-title"]}>{title}</div>
      </div>
      <div
        className={styles["reception-order-step-two-field"]}
        data-automation-id="input-search"
      >
        <DeviceSelector
          enabled={enabledRead}
          typeRead={typeRead}
          refRead={refRead}
          associateRead={associateRead}
          priorityRead={priorityRead}
          receiveEvent={receiveEvent}
          includeType={"MOB_READER"}
        />
        <div style={{ marginTop: "10px" }}>
          <TagReadInput searchedValue={searchedValue} searchValue={searchValue} handleSubmit={handleSearch} />
        </div>

        <div className={styles["reception-order-step-two__tags-reads"]}>
          <article>
            <div>
              <picture>
                <img src={tagIcon} alt="tag icon" />
              </picture>
              <h4>{i18n.t("tags.read")}</h4>
            </div>
            <span >{originalItems.length}</span>
          </article>
        </div>
        <div className={styles["load-movement-items-list"]}>
          {selectedItems &&
            selectedItems.map((item) => {
              return (
                <ItemTags
                  key={item.sku}
                  item={item}
                  quantity={item.tags.length}
                  expected={item.expectedUnits}
                  handleDelete={handleDelete}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
  return (
    <div className={styles["reception-order-step-two-container"]}>
      <Step content={stepContent}></Step>
    </div>
  );
};

export default ReceptionOrderStep2;
